import HTTP from "./ajax";
import {
  apiEndpoints as ApiEndpoints,
  countryCodeFromDomain as CountryCodeFromDomain,
  googleApiEndpoints as GoogleApiEndpoints,
  site,
  env,
} from "./apiEndpoints";
import Utility from "../helpers/utility";
import ApiKeys from "./apiKeys";

const GEOCODE_API = async ({ headers, payload }) => {
  let url = payload.latitude
    ? `${ApiEndpoints.GEOCODE}?latitude=${payload.latitude}&longitude=${
        payload.longitude
      }&v=${Utility.randomnumber()}&site=${site}`
    : `${ApiEndpoints.GEOCODE}?place_id=${
        payload.place_id
      }&v=${Utility.randomnumber()}&site=${site}`;
  return HTTP.get(url, { headers: headers }).catch((err) => {
    return err;
  });
};

const GOOGLE_GEOLOCATION_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${GoogleApiEndpoints.GOOGLE_GEO_LOCATION}?key=${ApiKeys.GOOGLE_MAPS_API_KEY_MAP[CountryCodeFromDomain][site][env]}&site=${site}`,
    payload,
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const STORE_DETAILS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.LOCATOR_STORES}/${
      payload.storeId
    }?v=${Utility.randomnumber()}&site=${site}`,
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const STORE_OFFERS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.STORE_OFFERS}/aggregateOffers?sortOn=SAVINGS&lang=en&forLeftNav=${payload}&site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const LAST_SUCCESSFULL_PAYMENT_API = async ({ headers }) => {
  return HTTP.get(`${ApiEndpoints.LAST_SUCCESSFULL_PAYMENT_NEXTGEN}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};
// const PAYMENT_OFFERS_API = async ({ headers }) => {
//   return HTTP.get(`${ApiEndpoints.STORE_OFFERS}/paymentOffers`, {
//     headers: headers,
//   }).catch((err) => {
//     return err;
//   });
// };

const BANNER_OFFERS_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.BANNER_OFFERS}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const LOCATOR_STORES_API = async ({ headers, payload }) => {
  let res;
  for (var i = 0; i < 1; i++) {
    try {
      res = await HTTP.post(`${ApiEndpoints.LOCATOR_STORES}`, payload, {
        headers: headers,
      });
      if (res?.data?.data?.addressComponent) {
        break;
      }
    } catch (e) {
      res = e;
    }
  }
  return res;
};

const NEAREST_STORE_API = async ({ headers, payload }) => {
  let res;
  for (var i = 0; i < 1; i++) {
    try {
      res = await HTTP.post(`${ApiEndpoints.NEAREST_STORE}`, payload, {
        headers: headers,
      });
      if (res?.data?.data?.addressComponent) {
        break;
      }
    } catch (e) {
      res = e;
    }
  }
  return res;
};

const ADVANCE_ORDER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.ADVANCE_TIME_ORDER}/advanceorder-time?site=${site}`,
    payload,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const LOCATOR_STORES_TAKEAWAY_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.LOCATOR_STORES_TAKEAWAY}?orderDeliveryType=${payload.orderType}&latitude=${payload.latitude}&longitude=${payload.longitude}&site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const LOCATOR_STORES_V3_API = async ({ headers, payload }) => {
  let url = payload.latitude
    ? `${ApiEndpoints.LOCATOR_STORES_TAKEAWAY}?latitude=${payload.latitude}&longitude=${payload.longitude}&site=${site}`
    : `${ApiEndpoints.LOCATOR_STORES_TAKEAWAY}?place_id=${payload.placeId}&site=${site}`;
  return HTTP.post(url, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const LOCATOR_AUTOCOMPLETE_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.AUTO_COMPLETE}?input=${payload.input}&site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const FORGOT_PASSWORD_API = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.FORGOT_PASSWORD, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const VALIDATE_OTP_CODE_API = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.VALIDATE_CODE, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const ANONYNMOUS_USER_API = async ({ headers, payload }) => {
  return HTTP.post(`${ApiEndpoints.ANONYMOUS_USER}`, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const LOGOUT_USER_API = async ({ headers, payload }) => {
  return HTTP.post(`${ApiEndpoints.LOGOUT_USER}`, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const PREVIOUS_ORDER_API = async ({ headers, payload }) =>
  await HTTP.get(
    `${ApiEndpoints.PREVIOUS_ORDER}/orders?${payload.filterKey}=${
      payload.filterValue
    }&userId=${payload.userId}&v=${Utility.randomnumber()}&site=${site}`,
    {
      headers: headers,
    }
  );

const PREVIOUS_SINGLE_ORDER_API = async ({ headers, payload }) =>
  await HTTP.get(
    `${ApiEndpoints.PREVIOUS_SINGLE_ORDER}/${payload.storeId}/reorder-item?limit=${payload.limit}&deliveryType=${payload.deliveryType}&site=${site}`,
    {
      headers: headers,
    }
  );

const REORDER_ITEMS_API = async ({ headers, payload }) =>
  await HTTP.get(
    `${ApiEndpoints.REORDER_ITEMS}/${payload.orderId}?site=${site}`,
    {
      headers: headers,
    }
  );

const PREVIOUS_ORDER_DETAILS_API = async ({ headers, payload }) =>
  await HTTP.get(
    `${ApiEndpoints.PREVIOUS_ORDER}/orders/${payload.id}?userId=${
      payload.userId
    }&v=${Utility.randomnumber()}&site=${site}`,
    {
      headers: headers,
    }
  );

const PREVIOUS_ORDER_BY_PAGE_API = async ({ headers, payload }) =>
  // in future we can also implement deliveryType filter
  await HTTP.get(
    `${ApiEndpoints.PREVIOUS_ORDER}/orders?${payload.filterKey}=${payload.filterValue}&pageNo=${payload.pageNo}&pageSize=10&userId=${payload.userId}&site=${site}`,
    {
      headers: headers,
    }
  );
const FAVOURITE_DATA_API = async ({ headers, payload }) =>
  await HTTP.get(`${ApiEndpoints.ALL_FAVOURITES}`, {
    headers: headers,
  });

const FAVOURITE_IDS_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.FAVOURITE_IDS}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const ADDTO_FAVOURITE_API = async ({ headers, payload }) => {
  return HTTP.post(`${ApiEndpoints.ADD_TO_FAVOURITE}`, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const REMOVE_FROM_FAVOURITE_API = async ({ headers, payload }) => {
  return HTTP.delete(`${ApiEndpoints.REMOVE_FROM_FAVOURITE}`, {
    data: payload,
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const SAVED_ADDRESSES_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.SAVED_ADDRESSES}${
      payload.userId
    }/addresses?v=${Utility.randomnumber()}&site=${site}`,
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const UPDATE_ADDRESS_API = async ({ headers, payload }) => {
  return HTTP.put(
    `${ApiEndpoints.UPDATE_ADDRESS}${payload?.addressId}?site=${site}`,
    { ...payload?.saveAddressRequest },
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const ADD_ADDRESS_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.ADD_ADDRESS}${payload.mobile}/addresses?site=${site}`,
    { ...payload.saveAddressRequest },
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const DELETE_ADDRESS_API = async ({ headers, payload }) => {
  return HTTP.delete(
    `${ApiEndpoints.DELETE_ADDRESS}${payload?.addressId}?site=${site}`,
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const INLINE_NOTIFICATION_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.INLINE_NOTIFICATION}?storeId=${payload.storeId}&lang=${
      payload.lang
    }&platform=${payload.platform}&site=${payload.site}&mobile=${
      payload.mobile || ""
    }`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const OFFER_TNC_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.OFFER_TNC}${payload.campaignId}/termsAndConditions?site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const APPLY_WELCOME_OFFER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.STORE_OFFERS}/promos?site=${site}`,
    payload,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const REMOVE_WELCOME_OFFER_API = async ({ headers, payload }) => {
  return HTTP.delete(`${ApiEndpoints.STORE_OFFERS}/promos?site=${site}`, {
    data: payload,
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

// const PAYMENT_OFFER_TNC_API = async ({ headers, payload }) => {
//   return HTTP.get(
//     `${ApiEndpoints.PAYMENT_OFFER_TNC}?offerId=${payload.offerId}&langId=${
//       payload.langId
//     }&platform=${payload.platform}&v=${Utility.randomnumber()}`,
//     {
//       headers: headers,
//     }
//   ).catch((err) => {
//     return err;
//   });
// };

const FINGERPRINT_INFO = async ({ headers, payload }) => {
  const { detectorData } = payload;
  return HTTP.post(
    `${ApiEndpoints.FINGERPRINT_INFO}?site=${site}`,
    detectorData,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

// const GET_CART_ITEMS_API = async ({ headers, payload }) => {
//   return HTTP.get(
//     `${ApiEndpoints.SYNC_CART_ITEMS}/${
//       payload.cartId
//     }?v=${Utility.randomnumber()}`,
//     {
//       headers: headers,
//     }
//   ).catch((err) => {
//     return err;
//   });
// };
const SG_INFO_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.SYNC_CART_ITEMS}/sg-info?site=${site}`, {
    headers: { ...headers },
  }).catch((err) => {
    return err;
  });
};

const GET_CART_ITEMS_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.SYNC_CART_ITEMS}/get?site=${site}`, {
    headers: { ...headers },
  }).catch((err) => {
    return err;
  });
};

const UPDATE_CART_ITEMS_API = async ({ headers, payload }) => {
  return HTTP.put(
    `${ApiEndpoints.SYNC_CART_ITEMS}/update?site=${site}`,
    {
      promos: payload?.explicitPromo,
      cartProperties: payload?.cartProperties,
      tip: payload?.tip,
      items: payload?.items,
      // deliveryInstructions: payload?.deliveryInstructions,
      additionalCharges: payload?.additionalCharges,
    },
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

// const CART_ITEMS_API = async ({ headers, payload }) => {
//   return HTTP.put(
//     `${ApiEndpoints.SYNC_CART_ITEMS}/${payload.cartId}/items`,
//     {
//       explicitPromo: payload?.explicitPromo,
//       cartId: payload?.cartId,
//       isWalletUsed: false,
//       tip: payload?.tip,
//       items: payload?.items,
//       deliveryInstructions: payload?.deliveryInstructions,
//       additionalCharges: [
//         {
//           chargeTypeCode: "K",
//           selected: null,
//         },
//       ],
//       orderDateTimeInSec: payload?.orderDateTimeInSec,
//     },
//     {
//       headers: headers,
//     }
//   ).catch((err) => {
//     return err;
//   });
// };

const CREATE_CART_ITEMS_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.SYNC_CART_ITEMS}/create?site=${site}`,
    {
      promos: payload?.explicitPromo,
      cartProperties: payload?.cartProperties,
      tip: payload?.tip,
      items: payload?.items,
      // deliveryInstructions: payload?.deliveryInstructions,
      additionalCharges: payload?.additionalCharges,
    },
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const HAMBURGER_ITEMS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.HAMBURGER_ITEMS}?lang=${payload.langId}&site=${payload.site}&storeId=${payload.storeId}&platform=${payload.platformId}&page=home`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const GET_MULTIPLE_RECOMMENDATION_API = async ({ headers, payload }) => {
  const { api, apiPayload, payloadObj } = payload;
  let queryParam = `store_id=${apiPayload.storeId}&user_frequency=${apiPayload.userFrequency}&platform=${apiPayload.platform}&sequence_set=${apiPayload.sequenceSet}&limit=${apiPayload.limit}&site=${apiPayload.site}`;

  if ("name" in payloadObj) {
    queryParam = queryParam + `&name=${apiPayload.name}`;
  } else if ("group_name" in payloadObj) {
    queryParam = queryParam + `&group_name=${apiPayload.name}`;
  }

  return await HTTP.get(`${api}?${queryParam}`, {
    headers: headers,
  });
};

const GET_USER_INFO_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.GET_USER_INFO}` +
      `${payload?.userId}?v=${Utility.randomnumber()}&site=${site}`,
    {
      headers: headers,
    }
  );
};

const UPDATE_USER_INFO_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.UPDATE_USER_INFO}?site=${site}`,
    {
      ...payload?.updateUserInfoObject,
    },
    {
      headers: headers,
    }
  );
};

const TRACK_ORDER_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.TRACK_ORDERS}?mobile=${payload.mobile}&order=${
      payload.order
    }&v=${Utility.randomnumber()}&site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const TRACK_ON_MAP = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.TRACK_ON_MAP}?store_id=${payload.storeId}&order_number=${
      payload.order
    }&order_date=${payload.orderTime}&userId=${
      payload.userId
    }&v=${Utility.randomnumber()}&site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const STATIC_WIDGET_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${payload.endPoint}?site=${payload.site}&lang=${payload.lang}&platform=${
      payload.platform
    }&page=${payload.page}&deliveryType=${
      payload.deliveryType
    }&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const POST_SUBMIT_TRACK_ORDER_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.TRACK_ORDER}/${
      payload.transactionId
    }?fetchOrderSummaryOnWait=true&v=${Utility.randomnumber()}&site=${site}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

//@todo add cancel order api
const CANCEL_ORDER_API = async ({ headers, payload }) => {};

const GENERATE_CART_ID_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.GENERATE_CART_ID}?site=${site}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};
const GET_GLOABL_UPSELLS_ITEMS_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.GLOBAL_UPSELLS_ITEMS}?site=${site}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

export default {
  GEOCODE_API,
  GOOGLE_GEOLOCATION_API,
  LOCATOR_STORES_API,
  STORE_DETAILS_API,
  STORE_OFFERS_API,
  NEAREST_STORE_API,
  LOCATOR_STORES_TAKEAWAY_API,
  LOCATOR_AUTOCOMPLETE_API,
  ANONYNMOUS_USER_API,
  LOGOUT_USER_API,
  PREVIOUS_ORDER_API,
  PREVIOUS_ORDER_BY_PAGE_API,
  FAVOURITE_DATA_API,
  FORGOT_PASSWORD_API,
  VALIDATE_OTP_CODE_API,
  FAVOURITE_IDS_API,
  ADDTO_FAVOURITE_API,
  REMOVE_FROM_FAVOURITE_API,
  SAVED_ADDRESSES_API,
  INLINE_NOTIFICATION_API,
  APPLY_WELCOME_OFFER_API,
  OFFER_TNC_API,
  REMOVE_WELCOME_OFFER_API,
  // PAYMENT_OFFER_TNC_API,
  // PAYMENT_OFFERS_API,
  BANNER_OFFERS_API,
  // CART_ITEMS_API,
  UPDATE_CART_ITEMS_API,
  CREATE_CART_ITEMS_API,
  UPDATE_ADDRESS_API,
  ADD_ADDRESS_API,
  DELETE_ADDRESS_API,
  HAMBURGER_ITEMS_API,
  GET_USER_INFO_API,
  UPDATE_USER_INFO_API,
  TRACK_ORDER_API,
  TRACK_ON_MAP,
  CANCEL_ORDER_API,
  GENERATE_CART_ID_API,
  GET_CART_ITEMS_API,
  PREVIOUS_ORDER_DETAILS_API,
  GET_GLOABL_UPSELLS_ITEMS_API,
  POST_SUBMIT_TRACK_ORDER_API,
  FINGERPRINT_INFO,
  SG_INFO_API,
  ADVANCE_ORDER_API,
  LAST_SUCCESSFULL_PAYMENT_API,
  LOCATOR_STORES_V3_API,
  PREVIOUS_SINGLE_ORDER_API,
  REORDER_ITEMS_API,
  STATIC_WIDGET_API,
  GET_MULTIPLE_RECOMMENDATION_API,
};
